import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=32f0b9b5&scoped=true"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"
import style0 from "./Blacklist.vue?vue&type=style&index=0&id=32f0b9b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0b9b5",
  null
  
)

export default component.exports